import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../Widgets.scss';
import moment from 'moment';
import './SupplyWidget.scss';
import Briefcase from '../../shared/Briefcase/Briefcase';
import classNames from 'classnames';
import Gazprom from '../../assets/img/gaz.png';
import RN from '../../assets/img/rn.png';
import LUC from '../../assets/img/luk.png';
import CommerceOffer from '../../shared/CommerceOffer/CommerceOffer';
import Supply from '../../shared/Supply/Supply';

class SupplyWidget extends Component {
    static propTypes = {
      userInfo: PropTypes.object,
      classPrefix: PropTypes.string,
      basketCnt: PropTypes.func,
      isBasket: PropTypes.bool,
      inAccounts: PropTypes.bool,
      accountId: PropTypes.array,
    };
    constructor(props) {
      super(props);

      moment.locale('ru');

      this.pageSetting = {
        title: 'Поставки для финансирования',
      };

      this.state = {
        activeSupply: null,
        showModal: false,
        sortField: {},
        findField: '',
        searcherValue: {
          datePlace: '',
          classificator: '',
          dateCompleted: '',
          delay: '',
          delayLeft: '',
          amount: '',
          nameCompany: '',
          companyGroup: '',
          verification: '',
        },
        supplies2: [
          {
            'id': 1,
            'datePlace': '06.10.18',
            'classificator': 'Имперский крейсер',
            'dateCompleted': '04.10.18',
            'delay': 109,
            'delayLeft': 70,
            'amount': 63764927,
            'nameCompany': 'Retrotex',
            'companyGroup': 'gaz',
            'verification': 3,
            'basket': false,
          },
          {
            'id': 2,
            'datePlace': '12.11.18',
            'classificator': 'Буровая установка ТМ-2000',
            'dateCompleted': '03.10.18',
            'delay': 95,
            'delayLeft': 61,
            'amount': 50868769,
            'nameCompany': 'Zanymax',
            'companyGroup': 'Роснефть',
            'verification': 2,
            'basket': true,
          },
          {
            'id': 3,
            'datePlace': '10.10.18',
            'classificator': 'Буровая установка ТМ-2000',
            'dateCompleted': '04.10.18',
            'delay': 89,
            'delayLeft': 60,
            'amount': 13570918,
            'nameCompany': 'Portica',
            'companyGroup': 'gaz',
            'verification': 2,
            'basket': false,
          },
          {
            'id': 4,
            'datePlace': '04.10.18',
            'classificator': 'Буровая установка ТМ-2000',
            'dateCompleted': '04.10.18',
            'delay': 100,
            'delayLeft': 61,
            'amount': 376246,
            'nameCompany': 'Ebidco',
            'companyGroup': 'gaz',
            'verification': 1,
            'basket': true,
          },
          {
            'id': 5,
            'datePlace': '04.10.18',
            'classificator': 'Имперский крейсер',
            'dateCompleted': '04.10.18',
            'delay': 110,
            'delayLeft': 66,
            'amount': 87713007,
            'nameCompany': 'Injoy',
            'companyGroup': 'gaz',
            'verification': 1,
            'basket': false,
          },
          {
            'id': 6,
            'datePlace': '04.10.18',
            'classificator': 'Имперский крейсер',
            'dateCompleted': '04.10.18',
            'delay': 113,
            'delayLeft': 64,
            'amount': 16848734,
            'nameCompany': 'Conjurica',
            'companyGroup': 'gaz',
            'verification': 1,
            'basket': false,
          },
          {
            'id': 7,
            'datePlace': '22.12.18',
            'classificator': 'Броня терминатора',
            'dateCompleted': '04.10.18',
            'delay': 115,
            'delayLeft': 75,
            'amount': 56147446,
            'nameCompany': 'Musaphics',
            'companyGroup': 'gaz',
            'verification': 1,
            'basket': false,
          },
          {
            'id': 8,
            'datePlace': '04.10.19',
            'classificator': 'Буровая установка ТМ-2000',
            'dateCompleted': '03.10.19',
            'delay': 80,
            'delayLeft': 80,
            'amount': 64253025,
            'nameCompany': 'Twiggery',
            'companyGroup': 'gaz',
            'verification': 3,
            'basket': false,
          },
          {
            'id': 9,
            'datePlace': '04.10.18',
            'classificator': 'Имперский крейсер',
            'dateCompleted': '06.11.18',
            'delay': 116,
            'delayLeft': 76,
            'amount': 49143625,
            'nameCompany': 'Soprano',
            'companyGroup': 'gaz',
            'verification': 3,
            'basket': false,
          },
          {
            'id': 10,
            'datePlace': '04.10.18',
            'classificator': 'Буровая установка ТМ-2000',
            'dateCompleted': '02.10.18',
            'delay': 80,
            'delayLeft': 78,
            'amount': 20281769,
            'nameCompany': 'Endipine',
            'companyGroup': 'gaz',
            'verification': 1,
            'basket': false,
          },
          {
            'id': 11,
            'datePlace': '04.10.18',
            'classificator': 'Буровая установка ТМ-2000',
            'dateCompleted': '04.10.18',
            'delay': 94,
            'delayLeft': 67,
            'amount': 17305409,
            'nameCompany': 'Hometown',
            'companyGroup': 'gaz',
            'verification': 1,
            'basket': false,
          },
          {
            'id': 12,
            'datePlace': '04.10.18',
            'classificator': 'Броня терминатора',
            'dateCompleted': '04.10.18',
            'delay': 83,
            'delayLeft': 79,
            'amount': 2277753,
            'nameCompany': 'Gallaxia',
            'companyGroup': 'gaz',
            'verification': 2,
            'basket': false,
          },
          {
            'id': 13,
            'datePlace': '04.10.18',
            'classificator': 'Имперский крейсер',
            'dateCompleted': '04.10.18',
            'delay': 115,
            'delayLeft': 72,
            'amount': 1600660,
            'nameCompany': 'Fortean',
            'companyGroup': 'gaz',
            'verification': 2,
            'basket': false,
          },
          {
            'id': 14,
            'datePlace': '04.10.18',
            'classificator': 'Буровая установка ТМ-2000',
            'dateCompleted': '04.10.18',
            'delay': 102,
            'delayLeft': 70,
            'amount': 72159374,
            'nameCompany': 'Beadzza',
            'companyGroup': 'gaz',
            'verification': 2,
            'basket': false,
          },
          {
            'id': 15,
            'datePlace': '04.10.18',
            'classificator': 'Имперский крейсер',
            'dateCompleted': '04.10.18',
            'delay': 92,
            'delayLeft': 79,
            'amount': 78002397,
            'nameCompany': 'Polaria',
            'companyGroup': 'gaz',
            'verification': 2,
            'basket': false,
          },
          {
            'id': 16,
            'datePlace': '04.10.18',
            'classificator': 'Броня терминатора',
            'dateCompleted': '04.10.18',
            'delay': 115,
            'delayLeft': 74,
            'amount': 96048223,
            'nameCompany': 'Freakin',
            'companyGroup': 'gaz',
            'verification': 2,
            'basket': false,
          },
          {
            'id': 17,
            'datePlace': '04.10.18',
            'classificator': 'Буровая установка ТМ-2000',
            'dateCompleted': '04.10.18',
            'delay': 94,
            'delayLeft': 77,
            'amount': 57112876,
            'nameCompany': 'Manglo',
            'companyGroup': 'gaz',
            'verification': 1,
            'basket': false,
          },
          {
            'id': 18,
            'datePlace': '04.10.18',
            'classificator': 'Буровая установка ТМ-2000',
            'dateCompleted': '04.10.18',
            'delay': 112,
            'delayLeft': 69,
            'amount': 12631998,
            'nameCompany': 'Accidency',
            'companyGroup': 'gaz',
            'verification': 3,
            'basket': false,
          },
          {
            'id': 19,
            'datePlace': '04.10.18',
            'classificator': 'Броня терминатора',
            'dateCompleted': '04.10.18',
            'delay': 85,
            'delayLeft': 60,
            'amount': 67984118,
            'nameCompany': 'Qualitern',
            'companyGroup': 'gaz',
            'verification': 3,
            'basket': false,
          },
          {
            'id': 20,
            'datePlace': '04.10.18',
            'classificator': 'Броня терминатора',
            'dateCompleted': '04.10.18',
            'delay': 111,
            'delayLeft': 77,
            'amount': 58054645,
            'nameCompany': 'Uniworld',
            'companyGroup': 'gaz',
            'verification': 1,
            'basket': false,
          },
          {
            'id': 21,
            'datePlace': '04.10.18',
            'classificator': 'Броня терминатора',
            'dateCompleted': '04.10.18',
            'delay': 119,
            'delayLeft': 65,
            'amount': 45851995,
            'nameCompany': 'Diginetic',
            'companyGroup': 'gaz',
            'verification': 1,
            'basket': false,
          },
          {
            'id': 22,
            'datePlace': '04.10.18',
            'classificator': 'Имперский крейсер',
            'dateCompleted': '04.10.18',
            'delay': 119,
            'delayLeft': 74,
            'amount': 38691387,
            'nameCompany': 'Vixo',
            'companyGroup': 'gaz',
            'verification': 3,
            'basket': false,
          },
          {
            'id': 23,
            'datePlace': '04.10.18',
            'classificator': 'Броня терминатора',
            'dateCompleted': '04.10.18',
            'delay': 108,
            'delayLeft': 79,
            'amount': 47402339,
            'nameCompany': 'Geeketron',
            'companyGroup': 'gaz',
            'verification': 3,
            'basket': false,
          },
          {
            'id': 24,
            'datePlace': '04.10.18',
            'classificator': 'Броня терминатора',
            'dateCompleted': '04.10.18',
            'delay': 120,
            'delayLeft': 61,
            'amount': 25428312,
            'nameCompany': 'Zentia',
            'companyGroup': 'gaz',
            'verification': 3,
            'basket': false,
          },
          {
            'id': 25,
            'datePlace': '04.10.18',
            'classificator': 'Буровая установка ТМ-2000',
            'dateCompleted': '04.10.18',
            'delay': 112,
            'delayLeft': 70,
            'amount': 2561637,
            'nameCompany': 'Furnitech',
            'companyGroup': 'gaz',
            'verification': 3,
            'basket': false,
          },
          {
            'id': 26,
            'datePlace': '04.10.18',
            'classificator': 'Имперский крейсер',
            'dateCompleted': '04.10.18',
            'delay': 101,
            'delayLeft': 68,
            'amount': 70541399,
            'nameCompany': 'Xiix',
            'companyGroup': 'gaz',
            'verification': 2,
            'basket': false,
          },
          {
            'id': 27,
            'datePlace': '04.10.18',
            'classificator': 'Буровая установка ТМ-2000',
            'dateCompleted': '04.10.18',
            'delay': 89,
            'delayLeft': 63,
            'amount': 16752887,
            'nameCompany': 'Earthwax',
            'companyGroup': 'gaz',
            'verification': 2,
            'basket': false,
          },
          {
            'id': 28,
            'datePlace': '04.10.18',
            'classificator': 'Имперский крейсер',
            'dateCompleted': '04.10.18',
            'delay': 83,
            'delayLeft': 68,
            'amount': 92387871,
            'nameCompany': 'Hotcakes',
            'companyGroup': 'gaz',
            'verification': 3,
            'basket': false,
          },
          {
            'id': 29,
            'datePlace': '04.10.18',
            'classificator': 'Имперский крейсер',
            'dateCompleted': '04.10.18',
            'delay': 88,
            'delayLeft': 61,
            'amount': 85328567,
            'nameCompany': 'Terascape',
            'companyGroup': 'gaz',
            'verification': 3,
            'basket': false,
          },
          {
            'id': 30,
            'datePlace': '04.10.18',
            'classificator': 'Имперский крейсер',
            'dateCompleted': '04.10.18',
            'delay': 94,
            'delayLeft': 64,
            'amount': 106513,
            'nameCompany': 'Talendula',
            'companyGroup': 'gaz',
            'verification': 3,
            'basket': false,
          },
          {
            'id': 31,
            'datePlace': '04.10.18',
            'classificator': 'Имперский крейсер',
            'dateCompleted': '04.10.18',
            'delay': 102,
            'delayLeft': 80,
            'amount': 62793434,
            'nameCompany': 'Techmania',
            'companyGroup': 'gaz',
            'verification': 1,
            'basket': false,
          },
          {
            'id': 32,
            'datePlace': '04.10.18',
            'classificator': 'Буровая установка ТМ-2000',
            'dateCompleted': '04.10.18',
            'delay': 95,
            'delayLeft': 64,
            'amount': 5266588,
            'nameCompany': 'Geoform',
            'companyGroup': 'gaz',
            'verification': 1,
            'basket': false,
          },
          {
            'id': 33,
            'datePlace': '04.10.18',
            'classificator': 'Буровая установка ТМ-2000',
            'dateCompleted': '04.10.18',
            'delay': 85,
            'delayLeft': 67,
            'amount': 86917945,
            'nameCompany': 'Snacktion',
            'companyGroup': 'gaz',
            'verification': 3,
            'basket': false,
          },
          {
            'id': 34,
            'datePlace': '04.10.18',
            'classificator': 'Броня терминатора',
            'dateCompleted': '04.10.18',
            'delay': 118,
            'delayLeft': 77,
            'amount': 67887501,
            'nameCompany': 'Isologia',
            'companyGroup': 'gaz',
            'verification': 3,
            'basket': false,
          },
          {
            'id': 35,
            'datePlace': '04.10.18',
            'classificator': 'Броня терминатора',
            'dateCompleted': '04.10.18',
            'delay': 98,
            'delayLeft': 66,
            'amount': 4085817,
            'nameCompany': 'Empirica',
            'companyGroup': 'gaz',
            'verification': 1,
            'basket': false,
          },
          {
            'id': 36,
            'datePlace': '04.10.18',
            'classificator': 'Буровая установка ТМ-2000',
            'dateCompleted': '04.10.18',
            'delay': 104,
            'delayLeft': 62,
            'amount': 14646134,
            'nameCompany': 'Ultrasure',
            'companyGroup': 'gaz',
            'verification': 1,
            'basket': false,
          },
          {
            'id': 37,
            'datePlace': '04.10.18',
            'classificator': 'Буровая установка ТМ-2000',
            'dateCompleted': '04.10.18',
            'delay': 86,
            'delayLeft': 73,
            'amount': 68800636,
            'nameCompany': 'Isoplex',
            'companyGroup': 'gaz',
            'verification': 2,
            'basket': false,
          },
          {
            'id': 38,
            'datePlace': '04.10.18',
            'classificator': 'Имперский крейсер',
            'dateCompleted': '04.10.18',
            'delay': 117,
            'delayLeft': 67,
            'amount': 43909644,
            'nameCompany': 'Honotron',
            'companyGroup': 'gaz',
            'verification': 1,
            'basket': false,
          },
          {
            'id': 39,
            'datePlace': '04.10.18',
            'classificator': 'Буровая установка ТМ-2000',
            'dateCompleted': '04.10.18',
            'delay': 110,
            'delayLeft': 71,
            'amount': 60349831,
            'nameCompany': 'Zoid',
            'companyGroup': 'gaz',
            'verification': 3,
            'basket': false,
          },
          {
            'id': 40,
            'datePlace': '04.10.18',
            'classificator': 'Имперский крейсер',
            'dateCompleted': '04.10.18',
            'delay': 108,
            'delayLeft': 78,
            'amount': 42913583,
            'nameCompany': 'Prowaste',
            'companyGroup': 'gaz',
            'verification': 1,
            'basket': false,
          },
        ],
        supplies_OLD: [
          {
            id: 1,
            basket: false,
            offer: false,
            datePlace: '08.10.2018',
            classificator: 'Инженерно-геологические и гидрологические изыскания',
            dateCompleted: '01.10.2018',
            delay: '90 ',
            delayLeft: '83 ',
            amount: '4 252 358',
            nameCompany: 'РН Уват-Нефтегаз ООО',
            companyGroup: 'rn',
            verification: '1/3',
          },
          {
            id: 2,
            basket: false,
            offer: false,
            datePlace: '08.10.2018',
            classificator: 'Разведочное бурение',
            dateCompleted: '02.10.2018',
            delay: '90 ',
            delayLeft: '84 ',
            amount: '8 964 332',
            nameCompany: 'Газпром добыча Уренгой ООО',
            companyGroup: 'rn',
            verification: '2/3',
          },
          {
            id: 3,
            basket: false,
            offer: false,
            datePlace: '08.10.2018',
            classificator: 'Проектные работы в области энергетики',
            dateCompleted: '03.10.2018',
            delay: '210 ',
            delayLeft: '191 ',
            amount: '65 300',
            nameCompany: 'Оренбург нефтепродукт ООО',
            companyGroup: 'luc',
            verification: '3/3',
          },
          {
            id: 4,
            basket: false,
            offer: false,
            datePlace: '08.10.2018',
            classificator: 'Инженерно-экологические изыскания',
            dateCompleted: '04.10.2018',
            delay: '210 ',
            delayLeft: '188 ',
            amount: '7 424 371',
            nameCompany: 'РН Уват-Нефтегаз ООО',
            companyGroup: 'gaz',
            verification: '2/3',
          },
          {
            id: 5,
            basket: false,
            offer: false,
            datePlace: '08.10.2018',
            classificator: 'Инженерно-геодезические изыскания',
            dateCompleted: '20.09.2018',
            delay: '210 ',
            delayLeft: '172 ',
            amount: '13 475 309',
            nameCompany: 'Газпром добыча Уренгой ООО',
            companyGroup: 'rn',
            verification: '0/3',
          },
          {
            id: 6,
            basket: false,
            offer: false,
            datePlace: '07.10.2018',
            classificator: 'Инженерно-геологические и гидрологические изыскания',
            dateCompleted: '21.09.2018',
            delay: '80 ',
            delayLeft: '73 ',
            amount: '4 252 358',
            nameCompany: 'Оренбург нефтепродукт ООО',
            companyGroup: 'luc',
            verification: '1/3',
          },
          {
            id: 7,
            basket: false,
            offer: false,
            datePlace: '07.10.2018',
            classificator: 'Разведочное бурение',
            dateCompleted: '22.09.2018',
            delay: '80 ',
            delayLeft: '72 ',
            amount: '8 964 332',
            nameCompany: 'РН Уват-Нефтегаз ООО',
            companyGroup: 'gaz',
            verification: '2/3',
          },
          {
            id: 8,
            basket: false,
            offer: false,
            datePlace: '07.10.2018',
            classificator: 'Проектные работы в области энергетики',
            dateCompleted: '23.09.2018',
            delay: '80 ',
            delayLeft: '60 ',
            amount: '65 300',
            nameCompany: 'Газпром добыча Уренгой ООО',
            companyGroup: 'rn',
            verification: '3/3',
          },
          {
            id: 9,
            basket: false,
            offer: false,
            datePlace: '07.10.2018',
            classificator: 'Инженерно-экологические изыскания',
            dateCompleted: '24.09.2018',
            delay: '80 ',
            delayLeft: '30 ',
            amount: '7 424 371',
            nameCompany: 'Оренбург нефтепродукт ООО',
            companyGroup: 'luc',
            verification: '2/3',
          },
          {
            id: 10,
            basket: false,
            offer: false,
            datePlace: '07.10.2018',
            classificator: 'Инженерно-геодезические изыскания',
            dateCompleted: '05.09.2018',
            delay: '80 ',
            delayLeft: '56 ',
            amount: '13 475 309',
            nameCompany: 'РН Уват-Нефтегаз ООО',
            companyGroup: 'gaz',
            verification: '0/3',
          },
          {
            id: 11,
            basket: false,
            offer: false,
            datePlace: '06.10.2018',
            classificator: 'Инженерно-геологические и гидрологические изыскания',
            dateCompleted: '06.09.2018',
            delay: '90 ',
            delayLeft: '63 ',
            amount: '4 252 358',
            nameCompany: 'Газпром добыча Уренгой ООО',
            companyGroup: 'rn',
            verification: '1/3',
          },
          {
            id: 12,
            basket: false,
            offer: false,
            datePlace: '06.10.2018',
            classificator: 'Разведочное бурение',
            dateCompleted: '07.09.2018',
            delay: '90 ',
            delayLeft: '77 ',
            amount: '8 964 332',
            nameCompany: 'Оренбург нефтепродукт ООО',
            companyGroup: 'luc',
            verification: '2/3',
          },
          {
            id: 13,
            basket: false,
            offer: false,
            datePlace: '06.10.2018',
            classificator: 'Проектные работы в области энергетики',
            dateCompleted: '08.09.2018',
            delay: '90 ',
            delayLeft: '81 ',
            amount: '65 300',
            nameCompany: 'РН Уват-Нефтегаз ООО',
            companyGroup: 'gaz',
            verification: '3/3',
          },
          {
            id: 14,
            basket: false,
            offer: false,
            datePlace: '06.10.2018',
            classificator: 'Инженерно-экологические изыскания',
            dateCompleted: '09.09.2018',
            delay: '90 ',
            delayLeft: '62 ',
            amount: '7 424 371',
            nameCompany: 'Газпром добыча Уренгой ООО',
            companyGroup: 'rn',
            verification: '2/3',
          },
          {
            id: 15,
            basket: false,
            offer: false,
            datePlace: '06.10.2018',
            classificator: 'Инженерно-геодезические изыскания',
            dateCompleted: '10.09.2018',
            delay: '90 ',
            delayLeft: '42 ',
            amount: '13 475 309',
            nameCompany: 'Оренбург нефтепродукт ООО',
            companyGroup: 'luc',
            verification: '0/3',
          },
          {
            id: 16,
            basket: false,
            offer: false,
            datePlace: '08.10.2018',
            classificator: 'Инженерно-геологические и гидрологические изыскания',
            dateCompleted: '01.10.2018',
            delay: '90 ',
            delayLeft: '83 ',
            amount: '4 252 358',
            nameCompany: 'РН Уват-Нефтегаз ООО',
            companyGroup: 'gaz',
            verification: '1/3',
          },
          {
            id: 17,
            basket: false,
            offer: false,
            datePlace: '08.10.2018',
            classificator: 'Разведочное бурение',
            dateCompleted: '02.10.2018',
            delay: '90 ',
            delayLeft: '84 ',
            amount: '8 964 332',
            nameCompany: 'Газпром добыча Уренгой ООО',
            companyGroup: 'rn',
            verification: '2/3',
          },
          {
            id: 18,
            basket: false,
            offer: false,
            datePlace: '08.10.2018',
            classificator: 'Проектные работы в области энергетики',
            dateCompleted: '03.10.2018',
            delay: '210 ',
            delayLeft: '191 ',
            amount: '65 300',
            nameCompany: 'Оренбург нефтепродукт ООО',
            companyGroup: 'luc',
            verification: '3/3',
          },
          {
            id: 19,
            basket: false,
            offer: false,
            datePlace: '08.10.2018',
            classificator: 'Инженерно-экологические изыскания',
            dateCompleted: '04.10.2018',
            delay: '210 ',
            delayLeft: '188 ',
            amount: '7 424 371',
            nameCompany: 'РН Уват-Нефтегаз ООО',
            companyGroup: 'rn',
            verification: '2/3',
          },
          {
            id: 20,
            basket: false,
            offer: false,
            datePlace: '08.10.2018',
            classificator: 'Инженерно-геодезические изыскания',
            dateCompleted: '20.09.2018',
            delay: '210 ',
            delayLeft: '172 ',
            amount: '13 475 309',
            nameCompany: 'Газпром добыча Уренгой ООО',
            companyGroup: 'rn',
            verification: '0/3',
          },
          {
            id: 21,
            basket: false,
            offer: false,
            datePlace: '07.10.2018',
            classificator: 'Инженерно-геологические и гидрологические изыскания',
            dateCompleted: '21.09.2018',
            delay: '80 ',
            delayLeft: '73 ',
            amount: '4 252 358',
            nameCompany: 'Оренбург нефтепродукт ООО',
            companyGroup: 'luc',
            verification: '1/3',
          },
          {
            id: 22,
            basket: false,
            offer: false,
            datePlace: '07.10.2018',
            classificator: 'Разведочное бурение',
            dateCompleted: '22.09.2018',
            delay: '80 ',
            delayLeft: '72 ',
            amount: '8 964 332',
            nameCompany: 'РН Уват-Нефтегаз ООО',
            companyGroup: 'gaz',
            verification: '2/3',
          },
          {
            id: 23,
            basket: false,
            offer: false,
            datePlace: '07.10.2018',
            classificator: 'Проектные работы в области энергетики',
            dateCompleted: '23.09.2018',
            delay: '80 ',
            delayLeft: '60 ',
            amount: '65 300',
            nameCompany: 'Газпром добыча Уренгой ООО',
            companyGroup: 'rn',
            verification: '3/3',
          },
          {
            id: 24,
            basket: false,
            offer: false,
            datePlace: '07.10.2018',
            classificator: 'Инженерно-экологические изыскания',
            dateCompleted: '24.09.2018',
            delay: '80 ',
            delayLeft: '30 ',
            amount: '7 424 371',
            nameCompany: 'Оренбург нефтепродукт ООО',
            companyGroup: 'luc',
            verification: '2/3',
          },
          {
            id: 25,
            basket: false,
            offer: false,
            datePlace: '07.10.2018',
            classificator: 'Инженерно-геодезические изыскания',
            dateCompleted: '05.09.2018',
            delay: '80 ',
            delayLeft: '56 ',
            amount: '13 475 309',
            nameCompany: 'РН Уват-Нефтегаз ООО',
            companyGroup: 'gaz',
            verification: '0/3',
          },
          {
            id: 26,
            basket: false,
            offer: false,
            datePlace: '06.10.2018',
            classificator: 'Инженерно-геологические и гидрологические изыскания',
            dateCompleted: '06.09.2018',
            delay: '90 ',
            delayLeft: '63 ',
            amount: '4 252 358',
            nameCompany: 'Газпром добыча Уренгой ООО',
            companyGroup: 'rn',
            verification: '1/3',
          },
          {
            id: 27,
            basket: false,
            offer: false,
            datePlace: '06.10.2018',
            classificator: 'Разведочное бурение',
            dateCompleted: '07.09.2018',
            delay: '90 ',
            delayLeft: '77 ',
            amount: '8 964 332',
            nameCompany: 'Оренбург нефтепродукт ООО',
            companyGroup: 'luc',
            verification: '2/3',
          },
          {
            id: 28,
            basket: false,
            offer: false,
            datePlace: '06.10.2018',
            classificator: 'Проектные работы в области энергетики',
            dateCompleted: '08.09.2018',
            delay: '90 ',
            delayLeft: '81 ',
            amount: '65 300',
            nameCompany: 'РН Уват-Нефтегаз ООО',
            companyGroup: 'gaz',
            verification: '3/3',
          },
          {
            id: 29,
            basket: false,
            offer: false,
            datePlace: '06.10.2018',
            classificator: 'Инженерно-экологические изыскания',
            dateCompleted: '09.09.2018',
            delay: '90 ',
            delayLeft: '62 ',
            amount: '7 424 371',
            nameCompany: 'Газпром добыча Уренгой ООО',
            companyGroup: 'rn',
            verification: '2/3',
          },
          {
            id: 30,
            basket: false,
            offer: false,
            datePlace: '06.10.2018',
            classificator: 'Инженерно-геодезические изыскания',
            dateCompleted: '10.09.2018',
            delay: '90 ',
            delayLeft: '42 ',
            amount: '13 475 309',
            nameCompany: 'Оренбург нефтепродукт ООО',
            companyGroup: 'luc',
            verification: '0/3',
          },
        ], // TODO для верстки тестово - заменить бэк подгрузка поставок
        supplies: [
          {
            "id": 1,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "12.10.2018",
            "classificator": "Инженерно-геологические изыскания",
            "dateCompleted": "29.09.2018",
            "delay": "90",
            "delayLeft": "83",
            "amount": "41252000",
            "nameCompany": "РН-Уватнефтегаз ООО",
            "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
            "verification": "0",
            "supplyAgreementNumber": "3668-РН КС",
            "supplyAgreementDate": "21.07.2018",
            "supplyMore":
              {
                "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
                "supplyInterestRate": "31",
                "supplyPriceFinal": "8200000",
                "supplyInformation":
                  {
                    "supplyPrice": "1987400",
                    "supplyPriceClose": "1677300",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "2797000",
                    "supplyNumber": "92-18ФСТ",
                    "supplyStatus": "На рассмотрении"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Договор №3668-РН КС",
                      "supplyAgreementDate": "21.07.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    },
                    {
                      "supplyAgreementNumber": "Приложение №1",
                      "supplyAgreementDate": "29.08.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "23.09.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №12",
                      "supplyAgreementDate": "28.09.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 1,
            "debtor": {
              "name": "Игорь",
              "sureName": "Онешко",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (3452) 38 22 97",
              "email": "rn-uvatng@uvng.rosneft.ru",
              "site": "ung.rosneft.ru",
              "address": "625000, г. Тюмень, ул. Ленина,67",
              "avatar": "oneshko",
              "logo": "rn",
              "nameCompany": "РН-Уватнефтегаз ООО"
            },
            "idVendor": 1,
            "vendor": {
              "name": "Андрей",
              "sureName": "Королев",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (499) 941 09 04",
              "email": "info@akros-llc.com",
              "site": "akros-llc.com",
              "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
              "avatar": "korolev",
              "logo": "akros",
              "nameCompany": "Акрос ООО"
            }
          },
          {
            "id": 2,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "11.10.2018",
            "classificator": "Разведочное бурение",
            "dateCompleted": "24.09.2018",
            "delay": "90",
            "delayLeft": "84",
            "amount": "34172000",
            "nameCompany": "Газпром добыча Уренгой ООО",
            "companyGroup": {"icon": "gaz", "txt": "Газпром"},
            "verification": "1",
            "supplyAgreementNumber": "ГП-2018-567",
            "supplyAgreementDate": "01.05.2018",
            "supplyMore":
              {
                "supplyName": "Строительство разведочных и поисково-оценочной скважин",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2500000",
                "supplyInformation":
                  {
                    "supplyPrice": "3509800",
                    "supplyPriceClose": "12122900",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "0",
                    "supplyNumber": "93-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "ГП-2018-567",
                      "supplyAgreementDate": "01.05.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "01.08.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №56",
                      "supplyAgreementDate": "05.08.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 2,
            "debtor": {
              "name": "Александр",
              "sureName": "Корякин",
              "middleName": "Юрьевич",
              "position": "Генеральный директор",
              "phone": "8 (3494) 948 409",
              "email": "gdu@gd-urengoy.gazprom.ru",
              "site": "urengoy-dobycha.gazprom.ru",
              "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
              "avatar": "koryakin",
              "logo": "gaz",
              "nameCompany": "Газпром добыча Уренгой ООО"
            },
            "idVendor": 2,
            "vendor": {
              "name": "Алексей",
              "sureName": "Володин",
              "middleName": "Михайлович",
              "position": "Генеральный директор",
              "phone": "8 (4912) 308 193",
              "email": "pptkpo@tkpo.ryazan.ru",
              "site": "tkpo.ryazan.ru",
              "address": "390042, Россия, Рязань, Промышленная, 5",
              "avatar": "volodin",
              "logo": "tpm",
              "nameCompany": "ТяжПрессМаш ОАО"
            }
          },
          {
            "id": 3,
            "basket": false,
            "offer": false,
            "statusSupply": "deactive",
            "datePlace": "10.10.2018",
            "classificator": "Проектные работы в области энергетики",
            "dateCompleted": "21.09.2018",
            "delay": "210",
            "delayLeft": "129",
            "amount": "43952000",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
            "companyGroup": "luc",
            "verification": "0",
            "supplyAgreementNumber": "Л-2018.07-45",
            "supplyAgreementDate": "12.07.2018",
            "supplyMore":
              {
                "supplyName": "Проектирование, изготовление и поставка трансформаторной подстанции",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "16550000",
                "supplyInformation":
                  {
                    "supplyPrice": "32590000",
                    "supplyPriceClose": "7122900",
                    "supplyPriceReceivables": "20899",
                    "supplyPriceNetting": "437000",
                    "supplyNumber": "94-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Л-2018.07-45",
                      "supplyAgreementDate": "12.07.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №95",
                      "ssupplyAgreementDate":  "16.08.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №9",
                      "supplyAgreementDate": "21.08.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 3,
            "debtor": {
              "name": "Сергей",
              "sureName": "Кочкуров",
              "middleName": "Алексеевич",
              "position": "Генеральный директор",
              "phone": "8 (34667) 2 98 00",
              "email": "ws@lukoil.com",
              "site": "zs.lukoil.ru",
              "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
              "avatar": "kochkurov",
              "logo": "luk",
              "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
            },
            "idVendor": 3,
            "vendor": {
              "name": "Владимир",
              "sureName": "Шестериков",
              "middleName": "Савельевич",
              "position": "Генеральный директор",
              "phone": "8 (495) 2 257 595",
              "email": "cck@sibserv.com",
              "site": "sibserv.com",
              "address": "125284, г. Москва, Ленинградский проспект, д. 31А, стр.1, 9 этаж",
              "avatar": "shestakov",
              "logo": "sibserv",
              "nameCompany": "Сибирская Сервисная Компания АО"
            }
          },
          {
            "id": 4,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "10.10.2018",
            "classificator": "Разведочное бурение",
            "dateCompleted": "11.09.2018",
            "delay": "210",
            "delayLeft": "176",
            "amount": "39752000",
            "nameCompany": "РН-Уватнефтегаз ООО",
            "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
            "verification": "1",
            "supplyAgreementNumber": "3677-РН КС",
            "supplyAgreementDate": "21.07.2018",
            "supplyMore":
              {
                "supplyName": "Строительство разведочных и поисково-оценочной скважин",
                "supplyInterestRate": "31",
                "supplyPriceFinal": "8050000",
                "supplyInformation":
                  {
                    "supplyPrice": "11874000",
                    "supplyPriceClose": "2677300",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "2797000",
                    "supplyNumber": "92-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Договор №3677-РН КС",
                      "supplyAgreementDate": "21.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    },
                    {
                      "supplyAgreementNumber": "Приложение №1",
                      "supplyAgreementDate": "29.08.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "23.09.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №12",
                      "supplyAgreementDate": "28.09.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 1,
            "debtor": {
              "name": "Игорь",
              "sureName": "Онешко",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (3452) 38 22 97",
              "email": "rn-uvatng@uvng.rosneft.ru",
              "site": "ung.rosneft.ru",
              "address": "625000, г. Тюмень, ул. Ленина,67",
              "avatar": "oneshko",
              "logo": "rn",
              "nameCompany": "РН-Уватнефтегаз ООО"
            },
            "idVendor": 2,
            "vendor": {
              "name": "Алексей",
              "sureName": "Володин",
              "middleName": "Михайлович",
              "position": "Генеральный директор",
              "phone": "8 (4912) 308 193",
              "email": "pptkpo@tkpo.ryazan.ru",
              "site": "tkpo.ryazan.ru",
              "address": "390042, Россия, Рязань, Промышленная, 5",
              "avatar": "volodin",
              "logo": "tpm",
              "nameCompany": "ТяжПрессМаш ОАО"
            }
          },
          {
            "id": 5,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "09.10.2018",
            "classificator": "Разведочное бурение",
            "dateCompleted": "19.09.2018",
            "delay": "90",
            "delayLeft": "81",
            "amount": "41140000",
            "nameCompany": "Газпром добыча Уренгой ООО",
            "companyGroup": {"icon": "gaz", "txt": "Газпром"},
            "verification": "1",
            "supplyAgreementNumber": "ГП-2018-566",
            "supplyAgreementDate": "01.05.2018",
            "supplyMore":
              {
                "supplyName": "Строительство разведочных и поисково-оценочной скважин",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2510000",
                "supplyInformation":
                  {
                    "supplyPrice": "3959800",
                    "supplyPriceClose": "2122900",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "0",
                    "supplyNumber": "93-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "ГП-2018-566",
                      "supplyAgreementDate": "01.05.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "01.08.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №56",
                      "supplyAgreementDate": "05.08.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 2,
            "debtor": {
              "name": "Александр",
              "sureName": "Корякин",
              "middleName": "Юрьевич",
              "position": "Генеральный директор",
              "phone": "8 (3494) 948 409",
              "email": "gdu@gd-urengoy.gazprom.ru",
              "site": "urengoy-dobycha.gazprom.ru",
              "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
              "avatar": "koryakin",
              "logo": "gaz",
              "nameCompany": "Газпром добыча Уренгой ООО"
            },
            "idVendor": 2,
            "vendor": {
              "name": "Алексей",
              "sureName": "Володин",
              "middleName": "Михайлович",
              "position": "Генеральный директор",
              "phone": "8 (4912) 308 193",
              "email": "pptkpo@tkpo.ryazan.ru",
              "site": "tkpo.ryazan.ru",
              "address": "390042, Россия, Рязань, Промышленная, 5",
              "avatar": "volodin",
              "logo": "tpm",
              "nameCompany": "ТяжПрессМаш ОАО"
            }
          },
          {
            "id": 6,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "09.10.2018",
            "classificator": "Разведочное бурение",
            "dateCompleted": "29.08.2018",
            "delay": "90",
            "delayLeft": "79",
            "amount": "37552000",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
            "companyGroup": "luc",
            "verification": "3",
            "supplyAgreementNumber": "Л-2018.07-54",
            "supplyAgreementDate": "12.07.2018",
            "supplyMore":
              {
                "supplyName": "Строительство разведочных и поисково-оценочной скважин",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2655000",
                "supplyInformation":
                  {
                    "supplyPrice": "3259000",
                    "supplyPriceClose": "7122900",
                    "supplyPriceReceivables": "20899",
                    "supplyPriceNetting": "437050",
                    "supplyNumber": "94-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Л-2018.07-54",
                      "supplyAgreementDate": "12.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №95",
                      "ssupplyAgreementDate":  "16.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №9",
                      "supplyAgreementDate": "21.08.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 3,
            "debtor": {
              "name": "Сергей",
              "sureName": "Кочкуров",
              "middleName": "Алексеевич",
              "position": "Генеральный директор",
              "phone": "8 (34667) 2 98 00",
              "email": "ws@lukoil.com",
              "site": "zs.lukoil.ru",
              "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
              "avatar": "kochkurov",
              "logo": "luk",
              "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
            },
            "idVendor": 2,
            "vendor": {
              "name": "Алексей",
              "sureName": "Володин",
              "middleName": "Михайлович",
              "position": "Генеральный директор",
              "phone": "8 (4912) 308 193",
              "email": "pptkpo@tkpo.ryazan.ru",
              "site": "tkpo.ryazan.ru",
              "address": "390042, Россия, Рязань, Промышленная, 5",
              "avatar": "volodin",
              "logo": "tpm",
              "nameCompany": "ТяжПрессМаш ОАО"
            }
          },
          {
            "id": 7,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "09.10.2018",
            "classificator": "Инженерно-геологические изыскания",
            "dateCompleted": "20.09.2018",
            "delay": "90",
            "delayLeft": "83",
            "amount": "34852000",
            "nameCompany": "РН-Уватнефтегаз ООО",
            "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
            "verification": "3",
            "supplyAgreementNumber": "3676-РН КС",
            "supplyAgreementDate": "21.07.2018",
            "supplyMore":
              {
                "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
                "supplyInterestRate": "31",
                "supplyPriceFinal": "1800000",
                "supplyInformation":
                  {
                    "supplyPrice": "1987400",
                    "supplyPriceClose": "2677300",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "2797000",
                    "supplyNumber": "92-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Договор №3676-РН КС",
                      "supplyAgreementDate": "21.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    },
                    {
                      "supplyAgreementNumber": "Приложение №1",
                      "supplyAgreementDate": "29.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "23.09.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №12",
                      "supplyAgreementDate": "28.09.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 1,
            "debtor": {
              "name": "Игорь",
              "sureName": "Онешко",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (3452) 38 22 97",
              "email": "rn-uvatng@uvng.rosneft.ru",
              "site": "ung.rosneft.ru",
              "address": "625000, г. Тюмень, ул. Ленина,67",
              "avatar": "oneshko",
              "logo": "rn",
              "nameCompany": "РН-Уватнефтегаз ООО"
            },
            "idVendor": 1,
            "vendor": {
              "name": "Андрей",
              "sureName": "Королев",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (499) 941 09 04",
              "email": "info@akros-llc.com",
              "site": "akros-llc.com",
              "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
              "avatar": "korolev",
              "logo": "akros",
              "nameCompany": "Акрос ООО"
            }
          },
          {
            "id": 8,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "08.10.2018",
            "classificator": "Проектные работы в области энергетики",
            "dateCompleted": "12.09.2018",
            "delay": "210",
            "delayLeft": "188",
            "amount": "48352000",
            "nameCompany": "Газпром добыча Уренгой ООО",
            "companyGroup": {"icon": "gaz", "txt": "Газпром"},
            "verification": "3",
            "supplyAgreementNumber": "ГП-2018-565",
            "supplyAgreementDate": "01.05.2018",
            "supplyMore":
              {
                "supplyName": "Проектирование, изготовление и поставка трансформаторной подстанции",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2500000",
                "supplyInformation":
                  {
                    "supplyPrice": "3059800",
                    "supplyPriceClose": "2122900",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "0",
                    "supplyNumber": "93-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "ГП-2018-565",
                      "supplyAgreementDate": "01.05.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "01.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №56",
                      "supplyAgreementDate": "05.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 2,
            "debtor": {
              "name": "Александр",
              "sureName": "Корякин",
              "middleName": "Юрьевич",
              "position": "Генеральный директор",
              "phone": "8 (3494) 948 409",
              "email": "gdu@gd-urengoy.gazprom.ru",
              "site": "urengoy-dobycha.gazprom.ru",
              "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
              "avatar": "koryakin",
              "logo": "gaz",
              "nameCompany": "Газпром добыча Уренгой ООО"
            },
            "idVendor": 3,
            "vendor": {
              "name": "Владимир",
              "sureName": "Шестериков",
              "middleName": "Савельевич",
              "position": "Генеральный директор",
              "phone": "8 (495) 2 257 595",
              "email": "cck@sibserv.com",
              "site": "sibserv.com",
              "address": "125284, г. Москва, Ленинградский проспект, д. 31А, стр.1, 9 этаж",
              "avatar": "shestakov",
              "logo": "sibserv",
              "nameCompany": "Сибирская Сервисная Компания АО"
            }
          },
          {
            "id": 9,
            "basket": false,
            "offer": false,
            "statusSupply": "deactive",
            "datePlace": "08.10.2018",
            "classificator": "Инженерно-геологические изыскания",
            "dateCompleted": "03.09.2018",
            "delay": "210",
            "delayLeft": "149",
            "amount": "411252000",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
            "companyGroup": "luc",
            "verification": "2",
            "supplyAgreementNumber": "Л-2018.07-53",
            "supplyAgreementDate": "12.07.2018",
            "supplyMore":
              {
                "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2655000",
                "supplyInformation":
                  {
                    "supplyPrice": "3259000",
                    "supplyPriceClose": "7122900",
                    "supplyPriceReceivables": "20899",
                    "supplyPriceNetting": "437050",
                    "supplyNumber": "94-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Л-2018.07-53",
                      "supplyAgreementDate": "12.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №95",
                      "ssupplyAgreementDate":  "16.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №9",
                      "supplyAgreementDate": "21.08.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 3,
            "debtor": {
              "name": "Сергей",
              "sureName": "Кочкуров",
              "middleName": "Алексеевич",
              "position": "Генеральный директор",
              "phone": "8 (34667) 2 98 00",
              "email": "ws@lukoil.com",
              "site": "zs.lukoil.ru",
              "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
              "avatar": "kochkurov",
              "logo": "luk",
              "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
            },
            "idVendor": 1,
            "vendor": {
              "name": "Андрей",
              "sureName": "Королев",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (499) 941 09 04",
              "email": "info@akros-llc.com",
              "site": "akros-llc.com",
              "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
              "avatar": "korolev",
              "logo": "akros",
              "nameCompany": "Акрос ООО"
            }
          },
          {
            "id": 10,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "07.10.2018",
            "classificator": "Инженерно-геологические изыскания",
            "dateCompleted": "05.10.2018",
            "delay": "90",
            "delayLeft": "81",
            "amount": "47252000",
            "nameCompany": "РН-Уватнефтегаз ООО",
            "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
            "verification": "2",
            "supplyAgreementNumber": "3675-РН КС",
            "supplyAgreementDate": "21.07.2018",
            "supplyMore":
              {
                "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
                "supplyInterestRate": "31",
                "supplyPriceFinal": "8200000",
                "supplyInformation":
                  {
                    "supplyPrice": "9887400",
                    "supplyPriceClose": "2677300",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "2797000",
                    "supplyNumber": "92-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Договор №3675-РН КС",
                      "supplyAgreementDate": "21.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    },
                    {
                      "supplyAgreementNumber": "Приложение №1",
                      "supplyAgreementDate": "29.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "23.09.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №12",
                      "supplyAgreementDate": "28.09.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 1,
            "debtor": {
              "name": "Игорь",
              "sureName": "Онешко",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (3452) 38 22 97",
              "email": "rn-uvatng@uvng.rosneft.ru",
              "site": "ung.rosneft.ru",
              "address": "625000, г. Тюмень, ул. Ленина,67",
              "avatar": "oneshko",
              "logo": "rn",
              "nameCompany": "РН-Уватнефтегаз ООО"
            },
            "idVendor": 1,
            "vendor": {
              "name": "Андрей",
              "sureName": "Королев",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (499) 941 09 04",
              "email": "info@akros-llc.com",
              "site": "akros-llc.com",
              "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
              "avatar": "korolev",
              "logo": "akros",
              "nameCompany": "Акрос ООО"
            }
          },
          {
            "id": 11,
            "basket": false,
            "offer": false,
            "statusSupply": "deactive",
            "datePlace": "07.10.2018",
            "classificator": "Проектные работы в области энергетики",
            "dateCompleted": "02.10.2018",
            "delay": "90",
            "delayLeft": "84",
            "amount": "38964000",
            "nameCompany": "Газпром добыча Уренгой ООО",
            "companyGroup": {"icon": "gaz", "txt": "Газпром"},
            "verification": "3",
            "supplyAgreementNumber": "ГП-2018-564",
            "supplyAgreementDate": "01.05.2018",
            "supplyMore":
              {
                "supplyName": "Проектирование, изготовление и поставка трансформаторной подстанции",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2500000",
                "supplyInformation":
                  {
                    "supplyPrice": "3598000",
                    "supplyPriceClose": "2122900",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "0",
                    "supplyNumber": "93-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "ГП-2018-564",
                      "supplyAgreementDate": "01.05.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "01.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №56",
                      "supplyAgreementDate": "05.08.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 2,
            "debtor": {
              "name": "Александр",
              "sureName": "Корякин",
              "middleName": "Юрьевич",
              "position": "Генеральный директор",
              "phone": "8 (3494) 948 409",
              "email": "gdu@gd-urengoy.gazprom.ru",
              "site": "urengoy-dobycha.gazprom.ru",
              "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
              "avatar": "koryakin",
              "logo": "gaz",
              "nameCompany": "Газпром добыча Уренгой ООО"
            },
            "idVendor": 3,
            "vendor": {
              "name": "Владимир",
              "sureName": "Шестериков",
              "middleName": "Савельевич",
              "position": "Генеральный директор",
              "phone": "8 (495) 2 257 595",
              "email": "cck@sibserv.com",
              "site": "sibserv.com",
              "address": "125284, г. Москва, Ленинградский проспект, д. 31А, стр.1, 9 этаж",
              "avatar": "shestakov",
              "logo": "sibserv",
              "nameCompany": "Сибирская Сервисная Компания АО"
            }
          },
          {
            "id": 12,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "07.10.2018",
            "classificator": "Разведочное бурение",
            "dateCompleted": "03.10.2018",
            "delay": "90",
            "delayLeft": "32",
            "amount": "41265300",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
            "companyGroup": "luc",
            "verification": "3",
            "supplyAgreementNumber": "Л-2018.07-52",
            "supplyAgreementDate": "12.07.2018",
            "supplyMore":
              {
                "supplyName": "Строительство разведочных и поисково-оценочной скважин",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2655000",
                "supplyInformation":
                  {
                    "supplyPrice": "3259000",
                    "supplyPriceClose": "7122900",
                    "supplyPriceReceivables": "20899",
                    "supplyPriceNetting": "437050",
                    "supplyNumber": "94-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Л-2018.07-52",
                      "supplyAgreementDate": "12.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №95",
                      "ssupplyAgreementDate":  "16.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №9",
                      "supplyAgreementDate": "21.08.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 3,
            "debtor": {
              "name": "Сергей",
              "sureName": "Кочкуров",
              "middleName": "Алексеевич",
              "position": "Генеральный директор",
              "phone": "8 (34667) 2 98 00",
              "email": "ws@lukoil.com",
              "site": "zs.lukoil.ru",
              "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
              "avatar": "kochkurov",
              "logo": "luk",
              "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
            },
            "idVendor": 2,
            "vendor": {
              "name": "Алексей",
              "sureName": "Володин",
              "middleName": "Михайлович",
              "position": "Генеральный директор",
              "phone": "8 (4912) 308 193",
              "email": "pptkpo@tkpo.ryazan.ru",
              "site": "tkpo.ryazan.ru",
              "address": "390042, Россия, Рязань, Промышленная, 5",
              "avatar": "volodin",
              "logo": "tpm",
              "nameCompany": "ТяжПрессМаш ОАО"
            }
          },
          {
            "id": 13,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "07.10.2018",
            "classificator": "Инженерно-геологические изыскания",
            "dateCompleted": "29.09.2018",
            "delay": "90",
            "delayLeft": "72",
            "amount": "34252000",
            "nameCompany": "РН-Уватнефтегаз ООО",
            "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
            "verification": "3",
            "supplyAgreementNumber": "3674-РН КС",
            "supplyAgreementDate": "21.07.2018",
            "supplyMore":
              {
                "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
                "supplyInterestRate": "31",
                "supplyPriceFinal": "8000000",
                "supplyInformation":
                  {
                    "supplyPrice": "9087400",
                    "supplyPriceClose": "2677300",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "2797000",
                    "supplyNumber": "92-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Договор №3674-РН КС",
                      "supplyAgreementDate": "21.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    },
                    {
                      "supplyAgreementNumber": "Приложение №1",
                      "supplyAgreementDate": "29.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "23.09.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №12",
                      "supplyAgreementDate": "28.09.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 1,
            "debtor": {
              "name": "Игорь",
              "sureName": "Онешко",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (3452) 38 22 97",
              "email": "rn-uvatng@uvng.rosneft.ru",
              "site": "ung.rosneft.ru",
              "address": "625000, г. Тюмень, ул. Ленина,67",
              "avatar": "oneshko",
              "logo": "rn",
              "nameCompany": "РН-Уватнефтегаз ООО"
            },
            "idVendor": 1,
            "vendor": {
              "name": "Андрей",
              "sureName": "Королев",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (499) 941 09 04",
              "email": "info@akros-llc.com",
              "site": "akros-llc.com",
              "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
              "avatar": "korolev",
              "logo": "akros",
              "nameCompany": "Акрос ООО"
            }
          },
          {
            "id": 14,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "07.10.2018",
            "classificator": "Инженерно-геологические изыскания",
            "dateCompleted": "27.09.2018",
            "delay": "90",
            "delayLeft": "82",
            "amount": "38964000",
            "nameCompany": "Газпром добыча Уренгой ООО",
            "companyGroup": {"icon": "gaz", "txt": "Газпром"},
            "verification": "3",
            "supplyAgreementNumber": "ГП-2018-563",
            "supplyAgreementDate": "01.05.2018",
            "supplyMore":
              {
                "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2500000",
                "supplyInformation":
                  {
                    "supplyPrice": "3059800",
                    "supplyPriceClose": "2122900",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "0",
                    "supplyNumber": "93-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "ГП-2018-563",
                      "supplyAgreementDate": "01.05.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "01.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №56",
                      "supplyAgreementDate": "05.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 2,
            "debtor": {
              "name": "Александр",
              "sureName": "Корякин",
              "middleName": "Юрьевич",
              "position": "Генеральный директор",
              "phone": "8 (3494) 948 409",
              "email": "gdu@gd-urengoy.gazprom.ru",
              "site": "urengoy-dobycha.gazprom.ru",
              "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
              "avatar": "koryakin",
              "logo": "gaz",
              "nameCompany": "Газпром добыча Уренгой ООО"
            },
            "idVendor": 1,
            "vendor": {
              "name": "Андрей",
              "sureName": "Королев",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (499) 941 09 04",
              "email": "info@akros-llc.com",
              "site": "akros-llc.com",
              "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
              "avatar": "korolev",
              "logo": "akros",
              "nameCompany": "Акрос ООО"
            }
          },
          {
            "id": 15,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "07.10.2018",
            "classificator": "Разведочное бурение",
            "dateCompleted": "22.09.2018",
            "delay": "90",
            "delayLeft": "81",
            "amount": "41265000",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
            "companyGroup": "luc",
            "verification": "3",
            "supplyAgreementNumber": "Л-2018.07-51",
            "supplyAgreementDate": "12.07.2018",
            "supplyMore":
              {
                "supplyName": "Строительство разведочных и поисково-оценочной скважин",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2655000",
                "supplyInformation":
                  {
                    "supplyPrice": "3259000",
                    "supplyPriceClose": "7122900",
                    "supplyPriceReceivables": "20899",
                    "supplyPriceNetting": "437050",
                    "supplyNumber": "94-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Л-2018.07-51",
                      "supplyAgreementDate": "12.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №95",
                      "ssupplyAgreementDate":  "16.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №9",
                      "supplyAgreementDate": "21.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 3,
            "debtor": {
              "name": "Сергей",
              "sureName": "Кочкуров",
              "middleName": "Алексеевич",
              "position": "Генеральный директор",
              "phone": "8 (34667) 2 98 00",
              "email": "ws@lukoil.com",
              "site": "zs.lukoil.ru",
              "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
              "avatar": "kochkurov",
              "logo": "luk",
              "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
            },
            "idVendor": 2,
            "vendor": {
              "name": "Алексей",
              "sureName": "Володин",
              "middleName": "Михайлович",
              "position": "Генеральный директор",
              "phone": "8 (4912) 308 193",
              "email": "pptkpo@tkpo.ryazan.ru",
              "site": "tkpo.ryazan.ru",
              "address": "390042, Россия, Рязань, Промышленная, 5",
              "avatar": "volodin",
              "logo": "tpm",
              "nameCompany": "ТяжПрессМаш ОАО"
            }
          },
          {
            "id": 16,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "07.10.2018",
            "classificator": "Инженерно-геологические изыскания",
            "dateCompleted": "25.09.2018",
            "delay": "210",
            "delayLeft": "183",
            "amount": "44252000",
            "nameCompany": "РН-Уватнефтегаз ООО",
            "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
            "verification": "3",
            "supplyAgreementNumber": "3673-РН КС",
            "supplyAgreementDate": "21.07.2018",
            "supplyMore":
              {
                "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
                "supplyInterestRate": "31",
                "supplyPriceFinal": "8300000",
                "supplyInformation":
                  {
                    "supplyPrice": "9387400",
                    "supplyPriceClose": "2677300",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "2797000",
                    "supplyNumber": "92-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Договор №3673-РН КС",
                      "supplyAgreementDate": "21.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    },
                    {
                      "supplyAgreementNumber": "Приложение №1",
                      "supplyAgreementDate": "29.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "23.09.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №12",
                      "supplyAgreementDate": "28.09.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 1,
            "debtor": {
              "name": "Игорь",
              "sureName": "Онешко",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (3452) 38 22 97",
              "email": "rn-uvatng@uvng.rosneft.ru",
              "site": "ung.rosneft.ru",
              "address": "625000, г. Тюмень, ул. Ленина,67",
              "avatar": "oneshko",
              "logo": "rn",
              "nameCompany": "РН-Уватнефтегаз ООО"
            },
            "idVendor": 1,
            "vendor": {
              "name": "Андрей",
              "sureName": "Королев",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (499) 941 09 04",
              "email": "info@akros-llc.com",
              "site": "akros-llc.com",
              "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
              "avatar": "korolev",
              "logo": "akros",
              "nameCompany": "Акрос ООО"
            }
          },
          {
            "id": 17,
            "basket": false,
            "offer": false,
            "statusSupply": "deactive",
            "datePlace": "07.10.2018",
            "classificator": "Инженерно-геологические изыскания",
            "dateCompleted": "23.09.2018",
            "delay": "210",
            "delayLeft": "189",
            "amount": "28964000",
            "nameCompany": "Газпром добыча Уренгой ООО",
            "companyGroup": {"icon": "gaz", "txt": "Газпром"},
            "verification": "3",
            "supplyAgreementNumber": "ГП-2018-562",
            "supplyAgreementDate": "01.05.2018",
            "supplyMore":
              {
                "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2500000",
                "supplyInformation":
                  {
                    "supplyPrice": "3459800",
                    "supplyPriceClose": "2122900",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "0",
                    "supplyNumber": "93-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "ГП-2018-562",
                      "supplyAgreementDate": "01.05.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "01.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №56",
                      "supplyAgreementDate": "05.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 2,
            "debtor": {
              "name": "Александр",
              "sureName": "Корякин",
              "middleName": "Юрьевич",
              "position": "Генеральный директор",
              "phone": "8 (3494) 948 409",
              "email": "gdu@gd-urengoy.gazprom.ru",
              "site": "urengoy-dobycha.gazprom.ru",
              "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
              "avatar": "koryakin",
              "logo": "gaz",
              "nameCompany": "Газпром добыча Уренгой ООО"
            },
            "idVendor": 1,
            "vendor": {
              "name": "Андрей",
              "sureName": "Королев",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (499) 941 09 04",
              "email": "info@akros-llc.com",
              "site": "akros-llc.com",
              "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
              "avatar": "korolev",
              "logo": "akros",
              "nameCompany": "Акрос ООО"
            }
          },
          {
            "id": 18,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "06.10.2018",
            "classificator": "Инженерно-геологические изыскания",
            "dateCompleted": "23.09.2018",
            "delay": "210",
            "delayLeft": "159",
            "amount": "31265000",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
            "companyGroup": "luc",
            "verification": "3",
            "supplyAgreementNumber": "Л-2018.07-50",
            "supplyAgreementDate": "12.07.2018",
            "supplyMore":
              {
                "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "12655000",
                "supplyInformation":
                  {
                    "supplyPrice": "13259000",
                    "supplyPriceClose": "17122900",
                    "supplyPriceReceivables": "20899",
                    "supplyPriceNetting": "437050",
                    "supplyNumber": "94-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Л-2018.07-50",
                      "supplyAgreementDate": "12.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №95",
                      "ssupplyAgreementDate":  "16.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №9",
                      "supplyAgreementDate": "21.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 3,
            "debtor": {
              "name": "Сергей",
              "sureName": "Кочкуров",
              "middleName": "Алексеевич",
              "position": "Генеральный директор",
              "phone": "8 (34667) 2 98 00",
              "email": "ws@lukoil.com",
              "site": "zs.lukoil.ru",
              "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
              "avatar": "kochkurov",
              "logo": "luk",
              "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
            },
            "idVendor": 1,
            "vendor": {
              "name": "Андрей",
              "sureName": "Королев",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (499) 941 09 04",
              "email": "info@akros-llc.com",
              "site": "akros-llc.com",
              "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
              "avatar": "korolev",
              "logo": "akros",
              "nameCompany": "Акрос ООО"
            }
          },
          {
            "id": 19,
            "basket": false,
            "offer": false,
            "statusSupply": "deactive",
            "datePlace": "06.10.2018",
            "classificator": "Проектные работы в области энергетики",
            "dateCompleted": "22.09.2018",
            "delay": "90",
            "delayLeft": "81",
            "amount": "40252000",
            "nameCompany": "РН-Уватнефтегаз ООО",
            "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
            "verification": "3",
            "supplyAgreementNumber": "3672-РН КС",
            "supplyAgreementDate": "21.07.2018",
            "supplyMore":
              {
                "supplyName": "Проектирование, изготовление и поставка трансформаторной подстанции",
                "supplyInterestRate": "31",
                "supplyPriceFinal": "8900000",
                "supplyInformation":
                  {
                    "supplyPrice": "9874000",
                    "supplyPriceClose": "26773000",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "2797000",
                    "supplyNumber": "92-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Договор №3672-РН КС",
                      "supplyAgreementDate": "21.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    },
                    {
                      "supplyAgreementNumber": "Приложение №1",
                      "supplyAgreementDate": "29.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "23.09.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №12",
                      "supplyAgreementDate": "28.09.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 1,
            "debtor": {
              "name": "Игорь",
              "sureName": "Онешко",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (3452) 38 22 97",
              "email": "rn-uvatng@uvng.rosneft.ru",
              "site": "ung.rosneft.ru",
              "address": "625000, г. Тюмень, ул. Ленина,67",
              "avatar": "oneshko",
              "logo": "rn",
              "nameCompany": "РН-Уватнефтегаз ООО"
            },
            "idVendor": 3,
            "vendor": {
              "name": "Владимир",
              "sureName": "Шестериков",
              "middleName": "Савельевич",
              "position": "Генеральный директор",
              "phone": "8 (495) 2 257 595",
              "email": "cck@sibserv.com",
              "site": "sibserv.com",
              "address": "125284, г. Москва, Ленинградский проспект, д. 31А, стр.1, 9 этаж",
              "avatar": "shestakov",
              "logo": "sibserv",
              "nameCompany": "Сибирская Сервисная Компания АО"
            }
          },
          {
            "id": 20,
            "basket": false,
            "offer": false,
            "statusSupply": "deactive",
            "datePlace": "06.10.2018",
            "classificator": "Проектные работы в области энергетики",
            "dateCompleted": "02.10.2018",
            "delay": "90",
            "delayLeft": "69",
            "amount": "48964000",
            "nameCompany": "Газпром добыча Уренгой ООО",
            "companyGroup": {"icon": "gaz", "txt": "Газпром"},
            "verification": "2",
            "supplyAgreementNumber": "ГП-2018-561",
            "supplyAgreementDate": "01.05.2018",
            "supplyMore":
              {
                "supplyName": "Проектирование, изготовление и поставка трансформаторной подстанции",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2500000",
                "supplyInformation":
                  {
                    "supplyPrice": "3509800",
                    "supplyPriceClose": "2122900",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "0",
                    "supplyNumber": "93-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "ГП-2018-561",
                      "supplyAgreementDate": "01.05.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "01.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №56",
                      "supplyAgreementDate": "05.08.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 2,
            "debtor": {
              "name": "Александр",
              "sureName": "Корякин",
              "middleName": "Юрьевич",
              "position": "Генеральный директор",
              "phone": "8 (3494) 948 409",
              "email": "gdu@gd-urengoy.gazprom.ru",
              "site": "urengoy-dobycha.gazprom.ru",
              "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
              "avatar": "koryakin",
              "logo": "gaz",
              "nameCompany": "Газпром добыча Уренгой ООО"
            },
            "idVendor": 3,
            "vendor": {
              "name": "Владимир",
              "sureName": "Шестериков",
              "middleName": "Савельевич",
              "position": "Генеральный директор",
              "phone": "8 (495) 2 257 595",
              "email": "cck@sibserv.com",
              "site": "sibserv.com",
              "address": "125284, г. Москва, Ленинградский проспект, д. 31А, стр.1, 9 этаж",
              "avatar": "shestakov",
              "logo": "sibserv",
              "nameCompany": "Сибирская Сервисная Компания АО"
            }
          },
          {
            "id": 21,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "06.10.2018",
            "classificator": "Инженерно-геологические изыскания",
            "dateCompleted": "29.09.2018",
            "delay": "90",
            "delayLeft": "84",
            "amount": "41250300",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
            "companyGroup": "luc",
            "verification": "3",
            "supplyAgreementNumber": "Л-2018.07-49",
            "supplyAgreementDate": "12.07.2018",
            "supplyMore":
              {
                "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2655000",
                "supplyInformation":
                  {
                    "supplyPrice": "3259000",
                    "supplyPriceClose": "7122900",
                    "supplyPriceReceivables": "20899",
                    "supplyPriceNetting": "437050",
                    "supplyNumber": "94-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Л-2018.07-49",
                      "supplyAgreementDate": "12.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №95",
                      "ssupplyAgreementDate":  "16.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №9",
                      "supplyAgreementDate": "21.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 3,
            "debtor": {
              "name": "Сергей",
              "sureName": "Кочкуров",
              "middleName": "Алексеевич",
              "position": "Генеральный директор",
              "phone": "8 (34667) 2 98 00",
              "email": "ws@lukoil.com",
              "site": "zs.lukoil.ru",
              "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
              "avatar": "kochkurov",
              "logo": "luk",
              "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
            },
            "idVendor": 1,
            "vendor": {
              "name": "Андрей",
              "sureName": "Королев",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (499) 941 09 04",
              "email": "info@akros-llc.com",
              "site": "akros-llc.com",
              "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
              "avatar": "korolev",
              "logo": "akros",
              "nameCompany": "Акрос ООО"
            }
          },
          {
            "id": 22,
            "basket": false,
            "offer": false,
            "statusSupply": "deactive",
            "datePlace": "06.10.2018",
            "classificator": "Инженерно-геологические изыскания",
            "dateCompleted": "01.10.2018",
            "delay": "90",
            "delayLeft": "83",
            "amount": "45252000",
            "nameCompany": "РН-Уватнефтегаз ООО",
            "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
            "verification": "3",
            "supplyAgreementNumber": "3671-РН КС",
            "supplyAgreementDate": "21.07.2018",
            "supplyMore":
              {
                "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
                "supplyInterestRate": "31",
                "supplyPriceFinal": "8900000",
                "supplyInformation":
                  {
                    "supplyPrice": "9987400",
                    "supplyPriceClose": "2677300",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "2797000",
                    "supplyNumber": "92-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Договор №3671-РН КС",
                      "supplyAgreementDate": "21.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    },
                    {
                      "supplyAgreementNumber": "Приложение №1",
                      "supplyAgreementDate": "29.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "23.09.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №12",
                      "supplyAgreementDate": "28.09.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 1,
            "debtor": {
              "name": "Игорь",
              "sureName": "Онешко",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (3452) 38 22 97",
              "email": "rn-uvatng@uvng.rosneft.ru",
              "site": "ung.rosneft.ru",
              "address": "625000, г. Тюмень, ул. Ленина,67",
              "avatar": "oneshko",
              "logo": "rn",
              "nameCompany": "РН-Уватнефтегаз ООО"
            },
            "idVendor": 1,
            "vendor": {
              "name": "Андрей",
              "sureName": "Королев",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (499) 941 09 04",
              "email": "info@akros-llc.com",
              "site": "akros-llc.com",
              "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
              "avatar": "korolev",
              "logo": "akros",
              "nameCompany": "Акрос ООО"
            }
          },
          {
            "id": 23,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "06.10.2018",
            "classificator": "Разведочное бурение",
            "dateCompleted": "17.09.2018",
            "delay": "90",
            "delayLeft": "84",
            "amount": "38964000",
            "nameCompany": "Газпром добыча Уренгой ООО",
            "companyGroup": {"icon": "gaz", "txt": "Газпром"},
            "verification": "3",
            "supplyAgreementNumber": "ГП-2018-560",
            "supplyAgreementDate": "01.05.2018",
            "supplyMore":
              {
                "supplyName": "Строительство разведочных и поисково-оценочной скважин",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2500000",
                "supplyInformation":
                  {
                    "supplyPrice": "3598000",
                    "supplyPriceClose": "2122900",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "0",
                    "supplyNumber": "93-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "ГП-2018-560",
                      "supplyAgreementDate": "01.05.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "01.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №56",
                      "supplyAgreementDate": "05.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 2,
            "debtor": {
              "name": "Александр",
              "sureName": "Корякин",
              "middleName": "Юрьевич",
              "position": "Генеральный директор",
              "phone": "8 (3494) 948 409",
              "email": "gdu@gd-urengoy.gazprom.ru",
              "site": "urengoy-dobycha.gazprom.ru",
              "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
              "avatar": "koryakin",
              "logo": "gaz",
              "nameCompany": "Газпром добыча Уренгой ООО"
            },
            "idVendor": 2,
            "vendor": {
              "name": "Алексей",
              "sureName": "Володин",
              "middleName": "Михайлович",
              "position": "Генеральный директор",
              "phone": "8 (4912) 308 193",
              "email": "pptkpo@tkpo.ryazan.ru",
              "site": "tkpo.ryazan.ru",
              "address": "390042, Россия, Рязань, Промышленная, 5",
              "avatar": "volodin",
              "logo": "tpm",
              "nameCompany": "ТяжПрессМаш ОАО"
            }
          },
          {
            "id": 24,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "05.10.2018",
            "classificator": "Разведочное бурение",
            "dateCompleted": "18.09.2018",
            "delay": "90",
            "delayLeft": "55",
            "amount": "51265000",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
            "companyGroup": "luc",
            "verification": "3",
            "supplyAgreementNumber": "Л-2018.07-48",
            "supplyAgreementDate": "12.07.2018",
            "supplyMore":
              {
                "supplyName": "Строительство разведочных и поисково-оценочной скважин",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2655000",
                "supplyInformation":
                  {
                    "supplyPrice": "3259000",
                    "supplyPriceClose": "7122900",
                    "supplyPriceReceivables": "20899",
                    "supplyPriceNetting": "437050",
                    "supplyNumber": "94-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Л-2018.07-48",
                      "supplyAgreementDate": "12.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №95",
                      "ssupplyAgreementDate":  "16.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №9",
                      "supplyAgreementDate": "21.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 3,
            "debtor": {
              "name": "Сергей",
              "sureName": "Кочкуров",
              "middleName": "Алексеевич",
              "position": "Генеральный директор",
              "phone": "8 (34667) 2 98 00",
              "email": "ws@lukoil.com",
              "site": "zs.lukoil.ru",
              "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
              "avatar": "kochkurov",
              "logo": "luk",
              "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
            },
            "idVendor": 2,
            "vendor": {
              "name": "Алексей",
              "sureName": "Володин",
              "middleName": "Михайлович",
              "position": "Генеральный директор",
              "phone": "8 (4912) 308 193",
              "email": "pptkpo@tkpo.ryazan.ru",
              "site": "tkpo.ryazan.ru",
              "address": "390042, Россия, Рязань, Промышленная, 5",
              "avatar": "volodin",
              "logo": "tpm",
              "nameCompany": "ТяжПрессМаш ОАО"
            }
          },
          {
            "id": 25,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "05.10.2018",
            "classificator": "Инженерно-геологические изыскания",
            "dateCompleted": "25.09.2018",
            "delay": "210",
            "delayLeft": "199",
            "amount": "42252000",
            "nameCompany": "РН-Уватнефтегаз ООО",
            "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
            "verification": "3",
            "supplyAgreementNumber": "3670-РН КС",
            "supplyAgreementDate": "21.07.2018",
            "supplyMore":
              {
                "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
                "supplyInterestRate": "31",
                "supplyPriceFinal": "800000",
                "supplyInformation":
                  {
                    "supplyPrice": "987400",
                    "supplyPriceClose": "2677300",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "2797000",
                    "supplyNumber": "92-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Договор №3670-РН КС",
                      "supplyAgreementDate": "21.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    },
                    {
                      "supplyAgreementNumber": "Приложение №1",
                      "supplyAgreementDate": "29.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "23.09.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №12",
                      "supplyAgreementDate": "28.09.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 1,
            "debtor": {
              "name": "Игорь",
              "sureName": "Онешко",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (3452) 38 22 97",
              "email": "rn-uvatng@uvng.rosneft.ru",
              "site": "ung.rosneft.ru",
              "address": "625000, г. Тюмень, ул. Ленина,67",
              "avatar": "oneshko",
              "logo": "rn",
              "nameCompany": "РН-Уватнефтегаз ООО"
            },
            "idVendor": 1,
            "vendor": {
              "name": "Андрей",
              "sureName": "Королев",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (499) 941 09 04",
              "email": "info@akros-llc.com",
              "site": "akros-llc.com",
              "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
              "avatar": "korolev",
              "logo": "akros",
              "nameCompany": "Акрос ООО"
            }
          },
          {
            "id": 26,
            "basket": false,
            "offer": false,
            "statusSupply": "deactive",
            "datePlace": "05.10.2018",
            "classificator": "Инженерно-геологические изыскания",
            "dateCompleted": "07.09.2018",
            "delay": "90",
            "delayLeft": "81",
            "amount": "38964000",
            "nameCompany": "Газпром добыча Уренгой ООО",
            "companyGroup": {"icon": "gaz", "txt": "Газпром"},
            "verification": "3",
            "supplyAgreementNumber": "ГП-2018-559",
            "supplyAgreementDate": "01.05.2018",
            "supplyMore":
              {
                "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2500000",
                "supplyInformation":
                  {
                    "supplyPrice": "3590800",
                    "supplyPriceClose": "2122900",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "0",
                    "supplyNumber": "93-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "ГП-2018-559",
                      "supplyAgreementDate": "01.05.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "01.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №56",
                      "supplyAgreementDate": "05.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 2,
            "debtor": {
              "name": "Александр",
              "sureName": "Корякин",
              "middleName": "Юрьевич",
              "position": "Генеральный директор",
              "phone": "8 (3494) 948 409",
              "email": "gdu@gd-urengoy.gazprom.ru",
              "site": "urengoy-dobycha.gazprom.ru",
              "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
              "avatar": "koryakin",
              "logo": "gaz",
              "nameCompany": "Газпром добыча Уренгой ООО"
            },
            "idVendor": 1,
            "vendor": {
              "name": "Андрей",
              "sureName": "Королев",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (499) 941 09 04",
              "email": "info@akros-llc.com",
              "site": "akros-llc.com",
              "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
              "avatar": "korolev",
              "logo": "akros",
              "nameCompany": "Акрос ООО"
            }
          },
          {
            "id": 27,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "04.10.2018",
            "classificator": "Проектные работы в области энергетики",
            "dateCompleted": "03.09.2018",
            "delay": "90",
            "delayLeft": "72",
            "amount": "44265000",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
            "companyGroup": "luc",
            "verification": "3",
            "supplyAgreementNumber": "Л-2018.07-47",
            "supplyAgreementDate": "12.07.2018",
            "supplyMore":
              {
                "supplyName": "Проектирование, изготовление и поставка трансформаторной подстанции",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2655000",
                "supplyInformation":
                  {
                    "supplyPrice": "3259000",
                    "supplyPriceClose": "7122900",
                    "supplyPriceReceivables": "20899",
                    "supplyPriceNetting": "437050",
                    "supplyNumber": "94-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Л-2018.07-47",
                      "supplyAgreementDate": "12.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №95",
                      "ssupplyAgreementDate":  "16.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №9",
                      "supplyAgreementDate": "21.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 3,
            "debtor": {
              "name": "Сергей",
              "sureName": "Кочкуров",
              "middleName": "Алексеевич",
              "position": "Генеральный директор",
              "phone": "8 (34667) 2 98 00",
              "email": "ws@lukoil.com",
              "site": "zs.lukoil.ru",
              "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
              "avatar": "kochkurov",
              "logo": "luk",
              "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
            },
            "idVendor": 3,
            "vendor": {
              "name": "Владимир",
              "sureName": "Шестериков",
              "middleName": "Савельевич",
              "position": "Генеральный директор",
              "phone": "8 (495) 2 257 595",
              "email": "cck@sibserv.com",
              "site": "sibserv.com",
              "address": "125284, г. Москва, Ленинградский проспект, д. 31А, стр.1, 9 этаж",
              "avatar": "shestakov",
              "logo": "sibserv",
              "nameCompany": "Сибирская Сервисная Компания АО"
            }
          },
          {
            "id": 28,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "04.10.2018",
            "classificator": "Инженерно-геологические изыскания",
            "dateCompleted": "28.09.2018",
            "delay": "90",
            "delayLeft": "82",
            "amount": "41152000",
            "nameCompany": "РН-Уватнефтегаз ООО",
            "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
            "verification": "3",
            "supplyAgreementNumber": "3669-РН КС",
            "supplyAgreementDate": "21.07.2018",
            "supplyMore":
              {
                "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
                "supplyInterestRate": "31",
                "supplyPriceFinal": "8000000",
                "supplyInformation":
                  {
                    "supplyPrice": "9087400",
                    "supplyPriceClose": "2677300",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "2797000",
                    "supplyNumber": "92-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Договор №3669-РН КС",
                      "supplyAgreementDate": "21.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    },
                    {
                      "supplyAgreementNumber": "Приложение №1",
                      "supplyAgreementDate": "29.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "23.09.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №12",
                      "supplyAgreementDate": "28.09.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 1,
            "debtor": {
              "name": "Игорь",
              "sureName": "Онешко",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (3452) 38 22 97",
              "email": "rn-uvatng@uvng.rosneft.ru",
              "site": "ung.rosneft.ru",
              "address": "625000, г. Тюмень, ул. Ленина,67",
              "avatar": "oneshko",
              "logo": "rn",
              "nameCompany": "РН-Уватнефтегаз ООО"
            },
            "idVendor": 1,
            "vendor": {
              "name": "Андрей",
              "sureName": "Королев",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (499) 941 09 04",
              "email": "info@akros-llc.com",
              "site": "akros-llc.com",
              "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
              "avatar": "korolev",
              "logo": "akros",
              "nameCompany": "Акрос ООО"
            }
          },
          {
            "id": 29,
            "basket": false,
            "offer": false,
            "statusSupply": "active",
            "datePlace": "04.10.2018",
            "classificator": "Инженерно-геологические изыскания",
            "dateCompleted": "19.09.2018",
            "delay": "90",
            "delayLeft": "83",
            "amount": "37964000",
            "nameCompany": "Газпром добыча Уренгой ООО",
            "companyGroup": {"icon": "gaz", "txt": "Газпром"},
            "verification": "3",
            "supplyAgreementNumber": "ГП-2018-558",
            "supplyAgreementDate": "01.05.2018",
            "supplyMore":
              {
                "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2500000",
                "supplyInformation":
                  {
                    "supplyPrice": "3590800",
                    "supplyPriceClose": "2122900",
                    "supplyPriceReceivables": "0",
                    "supplyPriceNetting": "0",
                    "supplyNumber": "93-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "ГП-2018-558",
                      "supplyAgreementDate": "01.05.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №34",
                      "ssupplyAgreementDate":  "01.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №56",
                      "supplyAgreementDate": "05.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 2,
            "debtor": {
              "name": "Александр",
              "sureName": "Корякин",
              "middleName": "Юрьевич",
              "position": "Генеральный директор",
              "phone": "8 (3494) 948 409",
              "email": "gdu@gd-urengoy.gazprom.ru",
              "site": "urengoy-dobycha.gazprom.ru",
              "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
              "avatar": "koryakin",
              "logo": "gaz",
              "nameCompany": "Газпром добыча Уренгой ООО"
            },
            "idVendor": 1,
            "vendor": {
              "name": "Андрей",
              "sureName": "Королев",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (499) 941 09 04",
              "email": "info@akros-llc.com",
              "site": "akros-llc.com",
              "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
              "avatar": "korolev",
              "logo": "akros",
              "nameCompany": "Акрос ООО"
            }
          },
          {
            "id": 30,
            "basket": false,
            "offer": false,
            "statusSupply": "deactive",
            "datePlace": "03.10.2018",
            "classificator": "Инженерно-геологические изыскания",
            "dateCompleted": "02.10.2018",
            "delay": "210",
            "delayLeft": "189",
            "amount": "45650000",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
            "companyGroup": "luc",
            "verification": "3",
            "supplyAgreementNumber": "Л-2018.07-46",
            "supplyAgreementDate": "12.07.2018",
            "supplyMore":
              {
                "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
                "supplyInterestRate": "20",
                "supplyPriceFinal": "2655000",
                "supplyInformation":
                  {
                    "supplyPrice": "3259000",
                    "supplyPriceClose": "7122900",
                    "supplyPriceReceivables": "20899",
                    "supplyPriceNetting": "437050",
                    "supplyNumber": "94-18ФСТ",
                    "supplyStatus": "Сбор денег"
                  },
                "supplyDocuments": [{
                  "supplyAgreement": [
                    {
                      "supplyAgreementNumber": "Л-2018.07-46",
                      "supplyAgreementDate": "12.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyConfirm": [
                    {
                      "supplyAgreementNumber": "Акт выполненных работ №95",
                      "ssupplyAgreementDate":  "16.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},{
                  "supplyNetting": [
                    {
                      "supplyAgreementNumber": "Акт сверки №9",
                      "supplyAgreementDate": "21.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
                ]
              },
            "idDebtor": 3,
            "debtor": {
              "name": "Сергей",
              "sureName": "Кочкуров",
              "middleName": "Алексеевич",
              "position": "Генеральный директор",
              "phone": "8 (34667) 2 98 00",
              "email": "ws@lukoil.com",
              "site": "zs.lukoil.ru",
              "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
              "avatar": "kochkurov",
              "logo": "luk",
              "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
            },
            "idVendor": 1,
            "vendor": {
              "name": "Андрей",
              "sureName": "Королев",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (499) 941 09 04",
              "email": "info@akros-llc.com",
              "site": "akros-llc.com",
              "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
              "avatar": "korolev",
              "logo": "akros",
              "nameCompany": "Акрос ООО"
            }
          }
        ],
        tableDataEnd: true,
        originalSupplies: null,
        inSupply: false,
      };
    }

    componentWillMount() {
      const {accountId} = this.props;
      const {supplies} = this.state;
      // if (accountId) {
      //   if (accountId[0] === 'debtor') {
      //     const debArr = supplies.map(item => {
      //       return item.idDebtor === accountId[1].idDebtor && item
      //     }).filter(Boolean);
      //     this.setState({
      //       supplies: debArr,
      //     })
      //   }
      //   if (accountId[0] === 'vendor') {
      //     const venArr = supplies.map(item => {
      //       return item.idVendor === accountId[1].idVendor && item
      //     }).filter(Boolean);
      //     this.setState({
      //       supplies: venArr,
      //     })
      //   }
      // }
      document.addEventListener('click', this.checkOutsideClick, false);
      this.calculateAmount(this.state.supplies);
      this.setState({
        isSupply: false,
      });
    }

    componentDidMount() {
      const elem = document.getElementsByClassName('dataTable')[0];
      elem.addEventListener('scroll', () => {
        this.controllScrollinTable();
      });
    }

    componentWillUnmount() {
      document.removeEventListener('click', this.checkOutsideClick, false);
      const elem = document.getElementsByClassName('dataTable')[0];
      elem &&
        elem.removeEventListener('scroll', () => {
          this.controllScrollinTable();
        });
    }

    handleClickSupply = i => {
      this.setState({
        inSupply: !this.state.inSupply,
        activeSupply: i,
      });
    };

    controllScrollinTable() {
      const elem = document.getElementsByClassName('dataTable')[0];
        (elem.offsetHeight + elem.scrollTop >= elem.scrollHeight) ?
            this.setState({
              tableDataEnd: false,
            }) : this.setState({
              tableDataEnd: true,
            });
    }

    calculateAmount = (supp) => {
      const newObj = supp.map((item) => {
        const amount = item.amount.replace(/[^-0-9]/gi, '');
        let roundAmount;
        let textAmount;
        if (Math.trunc(amount / 1000000000) > 0) {
          roundAmount = Math.ceil(amount / 1000000000);
          textAmount = 'млрд. руб.';
        } else if (Math.trunc(amount / 1000000) > 0) {
          roundAmount = Math.ceil(amount / 1000000);
          textAmount = 'млн. руб.';
        } else {
          roundAmount = amount
              .toString()
              .replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, ' ');
          textAmount = 'руб.';
        }

        item.amountRound = {val: roundAmount, txt: textAmount};
        return item;
      });
      this.setState({
        supplies: newObj,
        originalSupplies: [...newObj],
      });
    };

     sortBy = (sortParam) => {
       const {supplies, originalSupplies} = this.state;
       const {field, type} = sortParam;
       if (type !== 'original') {
         switch (field) {
           case 'datePlace':
           case 'dateCompleted':
                (type === 'up') ?
                supplies.sort((a, b) =>
                    Date.parse(a[field]) < Date.parse(b[field]) ? 1 :
                    Date.parse(b[field]) < Date.parse(a[field]) ? -1 : 0) :
                    supplies.sort((a, b) =>
                    Date.parse(a[field]) > Date.parse(b[field]) ? 1 :
                    Date.parse(b[field]) > Date.parse(a[field]) ? -1 : 0);
             break;
           case 'delay':
           case 'delayLeft':
           case 'amount':
           case 'verification':
           case 'companyGroup':
             type === 'up' ?
               supplies.sort((a, b) =>
                 a[field].txt < b[field].txt ? 1 :
                   b[field].txt < a[field].txt ? -1 : 0) :
               supplies.sort((a, b) =>
                 a[field].txt > b[field].txt ? 1 :
                   b[field].txt > a[field].txt ? -1 : 0);
             break;
           case 'nameCompany':
           case 'classificator':
                type === 'up' ?
                    supplies.sort((a, b) =>
                    a[field] < b[field] ? 1 :
                    b[field] < a[field] ? -1 : 0) :
                    supplies.sort((a, b) =>
                    a[field] > b[field] ? 1 :
                    b[field] > a[field] ? -1 : 0);
             break;
           default:
             break;
         }
       } else {
         this.setState({
           supplies: [...originalSupplies],
         });
       }

       this.setState({
         sortField: sortParam,
       });
     };

    setSortSettings = (e) => {
      return new Promise((res, rej) => {
        const {sortField} = this.state;
        const sort = e.currentTarget.dataset.sort;
        const sortParam = Object.keys(sortField).length === 0 ?
                {field: sort, type: 'down'} :
                sortField.field === sort ? sortField.type === 'down' ?
                    {field: sort, type: 'up'} : sortField.type === 'up' ?
                        {field: sort, type: 'original'} :
                sortField.type === 'original' && {field: sort, type: 'down'} :
                    {field: sort, type: 'down'};
        res(sortParam);
      });
    };

    setFindSettings = (e) => {
      console.log(e);
      return new Promise((res, rej) => {
        const find = e.currentTarget.dataset.find;
        res(find);
      });
    };

    closeFind = (e) => {
      e.stopPropagation();
      e.preventDefault();
      this.setState({
        findField: '',
      });
    };

    findBy = (findField) => {
      this.setState({
        findField,
      });
    }

    handleSearcher = (e) => {
      const searchStr = e.target.value.toLowerCase();
      const {findField, originalSupplies, searcherValue} = this.state;
      let res;
      if (searchStr.length > 0) {
        res = [...originalSupplies].map((item) => {
          const findItem = item[findField].txt || item[findField];
          return findItem
              .toString()
              .toLowerCase()
              .indexOf(searchStr) !== -1 && item;})
              .filter(Boolean);
      } else {
        res = originalSupplies;
      }
      searcherValue[findField] = e.target.value;
      this.setState({
        supplies: res,
      });
    }

    handleSorting = (e) => {
      e.stopPropagation();
      this.setSortSettings(e).then((res) => res && this.sortBy(res));
    }

    handleFind = (e) => {
      e.stopPropagation();
      this.setFindSettings(e).then((res) => res && this.findBy(res));
    }

    handlerOffer = (idx, value) => {
      const {supplies} = this.state;
      const newObj = supplies[idx];
      newObj.offer = value;
      supplies.splice(idx, 1, newObj);
      this.setState({
        supplies,
      });
    }

    toggleBasket = (idx, value) => {
      const {basketCnt} = this.props;
      const {supplies} = this.state;
      const newObj = supplies[idx];
      newObj.basket = value;
      supplies.splice(idx, 1, newObj);
      const cnt = supplies.length ?
            supplies.filter((i) => i.basket) : [];
      sessionStorage.setItem('basketCount', cnt.length);
      basketCnt(cnt.length);
      this.setState({
        supplies,
      });
    }

    checkOutsideClick = (e) => {
      if (this.node) {
        if (this.node.contains(e.target)) {
          return true;
        }
      }
    };

    handleBackToTable = (inSupply) => {
      this.setState({
        inSupply: inSupply,
      })
    }

    sortingBlock = (type) => {
      const {sortField} = this.state;
      return (<div className={'sort'}>
        <div className={classNames(
            'down',
            {'active': sortField.type === 'down' && sortField.field === type})} />
        <div className={classNames(
            'up',
            {'active': sortField.type === 'up' && sortField.field === type})} />
      </div>);
    }

    get tableFormSupplies() {
      const {sortField, supplies, findField, searcherValue} = this.state;
      const {isBasket,accountId, inAccounts} = this.props;
      const idFiltr = accountId && accountId[1];
      const roleAcc = accountId &&  accountId[0];
      return (<div className={'suppliesTable'}>
        <div className={'suppliesTooltip'}>
          <div style={{width: '62%'}}>
                    Поставка (вполненный объем по договору)
          </div>
          <div style={{width: '30%'}}>
                    Дебитор
          </div>
        </div>
        <table>
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <tbody>
            <tr className={'suppliesTableHeader'}>
              <th className={'tableHeader'}
                data-sort={'datePlace'}
                onClick={this.handleSorting}>
                <div className={'up'}>Дата
                  <div className={classNames(
                      'ring',
                      {'active': sortField.field === 'datePlace'})} />
                  {this.sortingBlock('datePlace')}
                </div>
                <div className={'down'}>размещения</div>
              </th>
              <th className={'tableHeader'}
                data-sort={'classificator'}
                onClick={this.handleSorting}>
                <div className={'up'}>Тип
                  <div className={classNames(
                      'ring',
                      {'active': sortField.field === 'classificator'})} />
                  {this.sortingBlock('classificator')}
                </div>
                <div className={'down'}>в классификторе</div>
              </th>
              <th className={'tableHeader'} data-sort={'dateCompleted'}
                onClick={this.handleSorting}>
                <div className={'up'}>Дата
                  <div className={classNames(
                      'ring',
                      {'active': sortField.field === 'dateCompleted'})} />
                  {this.sortingBlock('dateCompleted')}
                </div>
                <div className={'down'}>совершения</div>
              </th>
              <th className={'tableHeader'}
                data-sort={'delay'}
                onClick={this.handleSorting}>
                <div className={'up'}>Отсрочка
                  <div className={classNames(
                      'ring',
                      {'active': sortField.field === 'delay'})} />
                  {this.sortingBlock('delay')}
                </div>
                <div className={'down'}>по договору</div>

              </th>
              <th className={'tableHeader'}
                data-sort={'delayLeft'}
                onClick={this.handleSorting}>
                <div className={'up'}>Отсрочка
                  <div className={classNames(
                      'ring',
                      {'active': sortField.field === 'delayLeft'})} />
                  {this.sortingBlock('delayLeft')}
                </div>
                <div className={'down'}>осталось</div>
              </th>
              <th className={'tableHeader'}
                data-sort={'amount'}
                onClick={this.handleSorting}>
                <div className={'up'}>Сумма
                  <div className={classNames(
                      'ring',
                      {'active': sortField.field === 'amount'})} />
                  {this.sortingBlock('amount')}
                </div>
                <div className={'down'}>по договору</div>

              </th>
              <th className={'tableHeader'}
                data-sort={'nameCompany'}
                onClick={this.handleSorting}>
                <div className={'up'}>Название
                  <div className={classNames(
                      'ring',
                      {'active': sortField.field === 'nameCompany'})} />
                  {this.sortingBlock('nameCompany')}
                </div>
                <div className={'down'}>юр. лица</div>
              </th>
              <th className={'tableHeader'}
                data-sort={'companyGroup'}
                onClick={this.handleSorting}>
                <div className={'up'}>Группа
                  <div className={classNames(
                      'ring',
                      {'active': sortField.field === 'companyGroup'})} />
                  {this.sortingBlock('companyGroup')}
                </div>
                <div className={'down'}>компаний</div>

              </th>
              <th className={'tableHeader'}
                data-sort={'verification'}
                onClick={this.handleSorting}>
                <div className={'up'}>Верификация
                  <div className={classNames(
                      'ring',
                      {'active': sortField.field === 'verification'})} />
                  {this.sortingBlock('verification')}
                </div>
                <div className={'down'}>поставки</div>
              </th>
              <th className={'tableHeader'} style={{width: '20px'}} />
            </tr>
          </tbody>
        </table>
        <table>
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <tbody>
            <tr className={'suppliesTableHeader'}>
              <th className={'tableHeader'}
                data-find={'datePlace'}
                onClick={this.handleFind}>
                <div className={'searchField'}>
                  <div className={classNames(
                      'inputField', {
                        'active': findField === 'datePlace',
                      })}>
                    <input
                      ref={(node) => this.node = node}
                      type={'text'}
                      value={searcherValue[findField] || ''}
                      onChange={this.handleSearcher} />
                    <div className={'close'}
                      onClick={this.closeFind}>X</div>
                  </div>
                </div>
              </th>
              <th className={'tableHeader'}
                data-find={'classificator'}
                onClick={this.handleFind}>
                <div className={'searchField'}>
                  <div className={classNames(
                      'inputField', {
                        'active': findField === 'classificator',
                      })}>
                    <input
                      ref={(node) => this.node = node}
                      type={'text'}
                      value={searcherValue[findField] || ''}
                      onChange={this.handleSearcher} />
                    <div className={'close'}
                      onClick={this.closeFind}>X</div>
                  </div>
                </div>
              </th>
              <th className={'tableHeader'}
                data-find={'dateCompleted'}
                onClick={this.handleFind}>
                <div className={'searchField'}>
                  <div className={classNames(
                      'inputField', {
                        'active': findField === 'dateCompleted',
                      })}>
                    <input
                      ref={(node) => this.node = node}
                      type={'text'}
                      value={searcherValue[findField] || ''}
                      onChange={this.handleSearcher} />
                    <div className={'close'}
                      onClick={this.closeFind}>X</div>
                  </div>
                </div>
              </th>
              <th className={'tableHeader'}
                data-find={'delay'}
                onClick={this.handleFind}>
                <div className={'searchField'}>
                  <div className={classNames(
                      'inputField', {
                        'active': findField === 'delay',
                      })}>
                    <input
                      ref={(node) => this.node = node}
                      type={'text'}
                      value={searcherValue[findField]}
                      onChange={this.handleSearcher} />
                    <div className={'close'}
                      onClick={this.closeFind}>X</div>
                  </div>
                </div>
              </th>
              <th className={'tableHeader'}
                data-find={'delayLeft'}
                onClick={this.handleFind}>
                <div className={'searchField'}>
                  <div className={classNames(
                      'inputField', {
                        'active': findField === 'delayLeft',
                      })}>
                    <input
                      ref={(node) => this.node = node}
                      type={'text'}
                      value={searcherValue[findField]  || ''}
                      onChange={this.handleSearcher} />
                    <div className={'close'}
                      onClick={this.closeFind}>X</div>
                  </div>
                </div>
              </th>
              <th className={'tableHeader'}
                data-find={'amount'}
                onClick={this.handleFind}>
                <div className={'searchField'}>
                  <div className={classNames(
                      'inputField', {
                        'active': findField === 'amount',
                      })}>
                    <input
                      type={'text'}
                      ref={(node) => this.node = node}
                      value={searcherValue[findField] || ''}
                      onChange={this.handleSearcher} />
                    <div className={'close'}
                      onClick={this.closeFind}>X</div>
                  </div>
                </div>
              </th>
              <th className={'tableHeader'}
                data-find={'nameCompany'}
                onClick={this.handleFind}>
                <div className={'searchField'}>
                  <div className={classNames(
                      'inputField', {
                        'active': findField === 'nameCompany',
                      })}>
                    <input
                      ref={(node) => this.node = node}
                      type={'text'}
                      value={searcherValue[findField] || ''}
                      onChange={this.handleSearcher} />
                    <div className={'close'}
                      onClick={this.closeFind}>X</div>
                  </div>
                </div>
              </th>
              <th className={'tableHeader'}
                data-find={'companyGroup'}
                onClick={this.handleFind}>
                <div className={'searchField'}>
                  <div className={classNames(
                      'inputField', {
                        'active': findField === 'companyGroup',
                      })}>
                    <input
                      ref={(node) => this.node = node}
                      type={'text'}
                      value={searcherValue[findField] || ''}
                      onChange={this.handleSearcher} />
                    <div className={'close'}
                      onClick={this.closeFind}>X</div>
                  </div>
                </div>
              </th>
              <th className={'tableHeader'}
                data-find={'verification'}
                onClick={this.handleFind}>
                <div className={'searchField'}>
                  <div className={classNames(
                      'inputField', {
                        'active': findField === 'verification',
                      })}>
                    <input
                      ref={(node) => this.node = node}
                      type={'text'}
                      value={searcherValue[findField] || ''}
                      onChange={this.handleSearcher} />
                    <div className={'close'}
                      onClick={this.closeFind}>X</div>
                  </div>
                </div>
              </th>
              <th className={'tableHeader'} style={{width: '49px'}} />
            </tr>
          </tbody>
        </table>
        <div className={'dataTable'}>
          <table>
            <colgroup>
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
            </colgroup>
            <tbody>
              {supplies.length > 0 && supplies.map((item, i) => {
                const {showModal} = this.state;
                return (isBasket && item.basket && !inAccounts) || (!inAccounts && !isBasket) ||
                  (roleAcc === 'debtor' && idFiltr.idDebtor === item.idDebtor)
                ||
                (roleAcc === 'vendor' && idFiltr.idVendor === item.idVendor)? (
                    <tr key={`supply_${i}`} className={'supplyItem'}
                      data-itemid={item.id}>
                      <td className={'supplyDatePlace'}
                        onClick={() => this.handleClickSupply(i)}>
                        {item.datePlace}
                      </td>
                      <td className={classNames('needTooltip', 'supplyClassificator')}
                        onClick={() => this.handleClickSupply(i)}>
                        <div className={'classsficator'}>
                          {item.classificator}
                        </div>
                        <span className={classNames('tooltiptext', 'right')}>{item.classificator}</span>
                      </td>
                      <td className={'supplyDateComplited'}
                        onClick={() => this.handleClickSupply(i)}>
                        {item.dateCompleted}
                      </td>
                      <td className={'supplyDelay'}
                        onClick={() => this.handleClickSupply(i)}>
                        <div className={'up'}>{item.delay}</div>
                        <div className={'down'}>дней</div>
                      </td>
                      <td className={'supplyDelayLeft'}
                        onClick={() => this.handleClickSupply(i)}>
                        <div className={'up'}>{item.delayLeft}</div>
                        <div className={'down'}>дней</div>
                      </td>
                      <td className={'supplyAmount'}
                        onClick={() => this.handleClickSupply(i)}>
                        <div className={'up'}>{item.amountRound.val}</div>
                        <div className={'down'}>{item.amountRound.txt}</div>
                      </td>
                      <td className={'supplyNameCompany'}
                        onClick={() => this.handleClickSupply(i)}>
                        {item.nameCompany}
                      </td>
                      <td className={'supplyCompanyGroup'}
                        onClick={() => this.handleClickSupply(i)}>
                        {item.companyGroup.icon === 'rn' ?
                            <img src={RN} alt={''} /> :
                            item.companyGroup.icon === 'gaz' ?
                                <img src={Gazprom} alt={''} width={25} height={25}/> :
                                <img src={LUC} alt={''} width={25} height={25}/>
                        }
                      </td>
                      <td className={'supplyVerification'}
                        onClick={() => this.handleClickSupply(i)}>
                        {item.verification}
                      </td>
                      <td className={'supplyBasket'}>
                        <Briefcase
                          objectId={item.id}
                          idx={i}
                          status={item.basket}
                          toggleBasket={this.toggleBasket} />
                        <CommerceOffer
                          status={item.offer}
                          objectId={item.id}
                          idx={i}
                          showModal={showModal}
                          toggleOffer={this.handlerOffer}/>
                      </td>

                    </tr>) : null;
              })}
            </tbody>
          </table>
        </div>
      </div>);
    }

    get emptyPage() {
      return (
        <div className={'empty'}>
          <div className={'txt'}>
                    Раздел в разработке
          </div>
          <div onClick={this.handleClickSupply} className={'emptypage'}>
                    вернуться на страницу Поставок
          </div>
        </div>);
    }

    render() {
      const {tableFormSupplies} = this;
      const {classPrefix, isBasket, inAccounts} = this.props;
      const {title} = this.pageSetting;
      const {tableDataEnd, inSupply, supplies, activeSupply} = this.state;
      if (inAccounts) {
        return tableFormSupplies
      } else {
        return (<div className={`contentBody${classPrefix}`} ref={(node) => this.node = node}>
          {!inSupply ? (<div className={'widgetTitle'}>
            {isBasket ? 'Портфель' : !inSupply ? title : 'Поставка'}
          </div>) : null}
          {isBasket ? (<div className={'xls'}>Выгрузить в XLS</div>) : null}
          {!inSupply || isBasket ? tableFormSupplies : <Supply supply={supplies[activeSupply]} handleBack={this.handleBackToTable}/>}
          {tableDataEnd && !inSupply ? (<div className={'gradient'} />) :
            null}
        </div>);
      }
    }
}

export default SupplyWidget;



// WEBPACK FOOTER //
// ./src/Widget/SupplyWidget/SupplyWidget.js